import type { RingMetric } from "../../components/screen0-ring/Screen0Ring";
import type { ViewMode } from "../../lib/habits/heatmap";
import { Capacitor } from "@capacitor/core";
import { useScreen0Language } from "@/features/language";
import { formatTemplate, getTranslations } from "@/i18n";
import { HeaderTextToggle } from "../habits/HabitsHeaderToggles";

type TodayHeaderTogglesProps = {
  viewMode: ViewMode;
  onViewModeToggle: () => void;
  metric: RingMetric;
  onMetricToggle: () => void;
};

const TODAY_TOGGLE_CLASS = "today-header-toggle shrink-0";
const TODAY_LABEL_CLASS = "col-start-1 row-start-1 whitespace-nowrap";

export function TodayHeaderToggles({
  viewMode,
  onViewModeToggle,
  metric,
  onMetricToggle,
}: TodayHeaderTogglesProps) {
  const { languageCode } = useScreen0Language();
  const t = getTranslations(languageCode);
  const isAndroid = Capacitor.getPlatform() === "android";

  const viewLabels: Record<ViewMode, string> = {
    app: t.today.viewApps,
    category: t.today.viewCategories,
  };
  const metricLabels: Record<RingMetric, string> = {
    time: isAndroid ? t.today.metricScreenTimeAndroid : t.today.metricScreenTime,
    opens: t.today.metricActivations,
  };

  return (
    <div className="flex items-center gap-1">
      <HeaderTextToggle
        label={viewLabels[viewMode]}
        onClick={onViewModeToggle}
        ariaLabel={formatTemplate(t.today.viewToggleAria, { view: viewLabels[viewMode] })}
        animateKey={viewMode}
        toggleClassName={TODAY_TOGGLE_CLASS}
        labelClassName={TODAY_LABEL_CLASS}
      />
      <HeaderTextToggle
        label={metricLabels[metric]}
        onClick={onMetricToggle}
        ariaLabel={formatTemplate(t.today.metricToggleAria, { metric: metricLabels[metric] })}
        animateKey={metric}
        toggleClassName={TODAY_TOGGLE_CLASS}
        labelClassName={TODAY_LABEL_CLASS}
      />
    </div>
  );
}
